import * as XLSX from "xlsx";
import { partsOf } from "@/lib/spot";
import { statusOf } from "@/lib/status";

export const linesOf = (r) => [
  ...(r.form_fee ? [{ ...r.form_fee, kind: "Form fee", src: { kind: "form_fee", index: 0 } }] : []),
  ...partsOf(r).map((p, i) => ({ ...p, kind: `Instalment ${i + 1}`, src: { kind: "part", index: i } })),
  ...(r.status === "admitted" && r.payment ? [{ ...r.payment, kind: "Final payment", src: { kind: "payment", index: 0 } }] : []),
];

export const verifyCount = (r) => {
  const lines = r.status === "partial" || r.status === "admitted" ? linesOf(r) : [];
  return { n: lines.filter((l) => l.verified).length, total: lines.length };
};
export const paymentStateLabel = ({ n, total }) => (!total ? "—" : n === total ? "Verified" : n === 0 ? "Not verified" : `${n} of ${total} verified`);

export const paidOf = (r) => linesOf(r).reduce((t, l) => t + (Number(l.amount) || 0), 0);
export const balanceOf = (r) => (r.status === "admitted" ? 0 : Math.max(0, (r.computed?.atAdmission || 0) - paidOf(r)));

const base = (r) => ({
  "Receipt No": r.receipt_no, "Child Name": r.inputs.childName, "Parent Name": r.inputs.parentName,
  Contact: r.inputs.contact, Email: r.inputs.email || "", Grade: r.inputs.grade, "Adm Counsellor": r.inputs.counselorName, Status: statusOf(r).label,
});

const sheet = (wb, rows, name) => {
  const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{ Note: "No records" }]);
  ws["!cols"] = Object.keys(rows[0] || { Note: 1 }).map((k) => ({ wch: Math.max(12, k.length + 2) }));
  XLSX.utils.book_append_sheet(wb, ws, name);
};

export const exportPaymentsXlsx = (rows, inRange, filename) => {
  const wb = XLSX.utils.book_new();
  const lines = rows.flatMap((r) => linesOf(r).filter(inRange).map((l) => ({
    "Payment Date": l.date, ...base(r), Type: l.kind, Amount: Number(l.amount) || 0, Mode: l.mode, Reference: l.reference || "", "Recorded By": l.recorded_by || "",
    "Recorded Late": l.late_days > 0 ? `${l.late_days} day(s) - ${l.late_reason || ""}` : "",
    Verified: l.verified ? "Yes" : "No", "Verified By": l.verified?.by || "", "Verified On": l.verified ? new Date(l.verified.at).toLocaleString("en-IN") : "",
  }))).sort((a, b) => a["Payment Date"].localeCompare(b["Payment Date"]));
  sheet(wb, lines, "Payments");
  sheet(wb, rows.map((r) => ({ ...base(r), "Due at Admission": r.computed.atAdmission, "Total Paid": paidOf(r), Balance: balanceOf(r), "Balance Due By": r.status === "partial" ? r.follow_up_date || "" : "" })), "Students");
  XLSX.writeFile(wb, filename);
};
